/**
 * @generated SignedSource<<f35e8f3239937f13dfedc067b866c427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mapEdgeToAgent$data = {
  readonly creatorType?: string | null;
  readonly description?: string | null;
  readonly id: string;
  readonly identityAccount?: {
    readonly id: string;
    readonly picture: AGG$URL;
  } | null;
  readonly isFavourite?: boolean | null;
  readonly isVerified?: boolean | null;
  readonly name: string | null;
  readonly " $fragmentType": "mapEdgeToAgent";
};
export type mapEdgeToAgent$key = {
  readonly " $data"?: mapEdgeToAgent$data;
  readonly " $fragmentSpreads": FragmentRefs<"mapEdgeToAgent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "mapEdgeToAgent"
};

(node as any).hash = "874147c17269a920001abdbc5847f9d5";

export default node;
